"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HousePriceIndexAttributes$ = exports.HousePriceIndexAttributes$outboundSchema = exports.HousePriceIndexAttributes$inboundSchema = void 0;
exports.housePriceIndexAttributesToJSON = housePriceIndexAttributesToJSON;
exports.housePriceIndexAttributesFromJSON = housePriceIndexAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const percentagechangebypropertytypeitem_js_1 = require("./percentagechangebypropertytypeitem.js");
const pricebypropertytypeitem_js_1 = require("./pricebypropertytypeitem.js");
/** @internal */
exports.HousePriceIndexAttributes$inboundSchema = z.object({
    date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    five_year_date_period: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    local_authority_average_price: z.nullable(z.number().int()),
    local_authority_average_price_by_property_type: z.array(pricebypropertytypeitem_js_1.PriceByPropertyTypeItem$inboundSchema),
    local_authority_average_price_five_years_ago: z.nullable(z.number().int()),
    local_authority_average_price_five_years_ago_by_property_type: z.array(pricebypropertytypeitem_js_1.PriceByPropertyTypeItem$inboundSchema),
    local_authority_average_price_one_year_ago: z.nullable(z.number().int()),
    local_authority_average_price_one_year_ago_by_property_type: z.array(pricebypropertytypeitem_js_1.PriceByPropertyTypeItem$inboundSchema),
    local_authority_name: z.string(),
    one_year_date_period: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    percentage_change_five_years_all_property_types: z.nullable(z.number()),
    percentage_change_five_years_by_property_type: z.array(percentagechangebypropertytypeitem_js_1.PercentageChangeByPropertyTypeItem$inboundSchema),
    percentage_change_yearly_all_property_types: z.nullable(z.number()),
    percentage_change_yearly_by_property_type: z.array(percentagechangebypropertytypeitem_js_1.PercentageChangeByPropertyTypeItem$inboundSchema),
    year_month: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "five_year_date_period": "fiveYearDatePeriod",
        "local_authority_average_price": "localAuthorityAveragePrice",
        "local_authority_average_price_by_property_type": "localAuthorityAveragePriceByPropertyType",
        "local_authority_average_price_five_years_ago": "localAuthorityAveragePriceFiveYearsAgo",
        "local_authority_average_price_five_years_ago_by_property_type": "localAuthorityAveragePriceFiveYearsAgoByPropertyType",
        "local_authority_average_price_one_year_ago": "localAuthorityAveragePriceOneYearAgo",
        "local_authority_average_price_one_year_ago_by_property_type": "localAuthorityAveragePriceOneYearAgoByPropertyType",
        "local_authority_name": "localAuthorityName",
        "one_year_date_period": "oneYearDatePeriod",
        "percentage_change_five_years_all_property_types": "percentageChangeFiveYearsAllPropertyTypes",
        "percentage_change_five_years_by_property_type": "percentageChangeFiveYearsByPropertyType",
        "percentage_change_yearly_all_property_types": "percentageChangeYearlyAllPropertyTypes",
        "percentage_change_yearly_by_property_type": "percentageChangeYearlyByPropertyType",
        "year_month": "yearMonth",
    });
});
/** @internal */
exports.HousePriceIndexAttributes$outboundSchema = z.object({
    date: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    fiveYearDatePeriod: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    localAuthorityAveragePrice: z.nullable(z.number().int()),
    localAuthorityAveragePriceByPropertyType: z.array(pricebypropertytypeitem_js_1.PriceByPropertyTypeItem$outboundSchema),
    localAuthorityAveragePriceFiveYearsAgo: z.nullable(z.number().int()),
    localAuthorityAveragePriceFiveYearsAgoByPropertyType: z.array(pricebypropertytypeitem_js_1.PriceByPropertyTypeItem$outboundSchema),
    localAuthorityAveragePriceOneYearAgo: z.nullable(z.number().int()),
    localAuthorityAveragePriceOneYearAgoByPropertyType: z.array(pricebypropertytypeitem_js_1.PriceByPropertyTypeItem$outboundSchema),
    localAuthorityName: z.string(),
    oneYearDatePeriod: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    percentageChangeFiveYearsAllPropertyTypes: z.nullable(z.number()),
    percentageChangeFiveYearsByPropertyType: z.array(percentagechangebypropertytypeitem_js_1.PercentageChangeByPropertyTypeItem$outboundSchema),
    percentageChangeYearlyAllPropertyTypes: z.nullable(z.number()),
    percentageChangeYearlyByPropertyType: z.array(percentagechangebypropertytypeitem_js_1.PercentageChangeByPropertyTypeItem$outboundSchema),
    yearMonth: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        fiveYearDatePeriod: "five_year_date_period",
        localAuthorityAveragePrice: "local_authority_average_price",
        localAuthorityAveragePriceByPropertyType: "local_authority_average_price_by_property_type",
        localAuthorityAveragePriceFiveYearsAgo: "local_authority_average_price_five_years_ago",
        localAuthorityAveragePriceFiveYearsAgoByPropertyType: "local_authority_average_price_five_years_ago_by_property_type",
        localAuthorityAveragePriceOneYearAgo: "local_authority_average_price_one_year_ago",
        localAuthorityAveragePriceOneYearAgoByPropertyType: "local_authority_average_price_one_year_ago_by_property_type",
        localAuthorityName: "local_authority_name",
        oneYearDatePeriod: "one_year_date_period",
        percentageChangeFiveYearsAllPropertyTypes: "percentage_change_five_years_all_property_types",
        percentageChangeFiveYearsByPropertyType: "percentage_change_five_years_by_property_type",
        percentageChangeYearlyAllPropertyTypes: "percentage_change_yearly_all_property_types",
        percentageChangeYearlyByPropertyType: "percentage_change_yearly_by_property_type",
        yearMonth: "year_month",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var HousePriceIndexAttributes$;
(function (HousePriceIndexAttributes$) {
    /** @deprecated use `HousePriceIndexAttributes$inboundSchema` instead. */
    HousePriceIndexAttributes$.inboundSchema = exports.HousePriceIndexAttributes$inboundSchema;
    /** @deprecated use `HousePriceIndexAttributes$outboundSchema` instead. */
    HousePriceIndexAttributes$.outboundSchema = exports.HousePriceIndexAttributes$outboundSchema;
})(HousePriceIndexAttributes$ || (exports.HousePriceIndexAttributes$ = HousePriceIndexAttributes$ = {}));
function housePriceIndexAttributesToJSON(housePriceIndexAttributes) {
    return JSON.stringify(exports.HousePriceIndexAttributes$outboundSchema.parse(housePriceIndexAttributes));
}
function housePriceIndexAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.HousePriceIndexAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'HousePriceIndexAttributes' from JSON`);
}
//# sourceMappingURL=housepriceindexattributes.js.map